import React from "react";
import {MultiSelectChipInput} from "~/apps/core/ui/ChipInput/MultiSelectChipInput";
import {FiberManualRecord} from "@mui/icons-material";
import {Grid} from "@mui/material";
import {getVesselCallStatusColor} from "~/apps/packages/vessel-calls/utils";
import {VesselCallShort} from "~/queries";

type Value = VesselCallShort["status"];

const CHOICES: Value[] = [
    "Ожидается",
    "На рейде",
    "В порту",
    "Завершен",
];


export type VesselCallStatusChipInputProps = {
    value?: Value[]
    onChange?: (value: Value[]) => any
    disabled?: boolean
}


export const VesselCallStatusChipInput = (props: VesselCallStatusChipInputProps) => {
    return (
        <MultiSelectChipInput {...props} title="Статус" options={
            CHOICES.map(choice => ({
                value: choice,
                title: (
                    <Grid container alignItems="center">
                        <FiberManualRecord style={{color: getVesselCallStatusColor(choice), width: 12, marginRight: 8}}/>
                        {choice}
                    </Grid>
                ),
            }))
        }/>
    )
}